module.exports = __webpack_public_path__ + "img/logo-login.86c6ad57.png";